const urlsToExecuteUpdate = [
    '/calculators/home-affordability-calculator',
    '/calculators/mortgage-calculator',
    '/calculators/rent-vs-buy-calculator',
    '/calculators/refinance-calculator',
    '/calculators/home-equity-calculator',
    '/calculators/amortization-calculator',
    '/mortgage-rates',
];

module.exports = urlsToExecuteUpdate;